export class GerenciamentoFilename {

  /**
  * Obtém o nome do arquivo.
  * @param content Conteúdo http obtido pela requisicao 
  */
  public static ObterBasicFileName(content: any) : string {
        
        var contentDisposition = content.headers.get('content-disposition');
        return  contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
    }
}




// WEBPACK FOOTER //
// ./src/app/shared/arquivo/filename-gerenciamento.ts